/**
 * "Contact your admin" from an invitation that can't be opened (D83). The
 * server (`functions/src/functions/contactInvitationAdmin.ts`) picks the admin
 * and sends the fixed notification, with its own limits; this only calls it.
 */
import { functionUrl } from '@/services/functionsUrl'
import { logger } from '@/services/logger'

export async function contactInvitationAdmin(
  invitationId: string
): Promise<boolean> {
  try {
    const res = await fetch(functionUrl('contactInvitationAdmin'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ invitationId }),
    })
    if (!res.ok) logger.warn('[contactInvitationAdmin] refused', res.status)
    return res.ok
  } catch (err) {
    logger.error('[contactInvitationAdmin] request failed', err)
    return false
  }
}
